import { object, array, string, number } from 'yup'

export const addBadgeConfigurationSchema = () =>
  object({
    title: string()
      .label('Badge Configuration Title')
      .trimmedRequired('Badge Configuration Title is required'),
    badgeBarColor: string().label('Badge Bar Color').required('Badge Bar Color is required'),
    fieldsAppliedInsideQRCode: array()
      .of(string().required('Each option must be a string'))
      .min(1, 'Please select at least one option')
      .required('Please select at least one option'),
    fieldsAppliedInsideBadge: array()
      .of(string().required('Each option must be a string'))
      .min(1, 'Please select at least one option')
      .required('Please select at least one item'),
    applicableSubjects: array()
      .of(string().required('Each option must be a string'))
      .min(1, 'Please select at least one option')
      .required('Please select at least one option')
  })

export const addBadgeSubjectSchema = () =>
  object({
    counter: number().min(1).label('Counter').required('Counter is required'),
    FullName: string().label('Full Name').trimmedRequired('Full Name is required'),
    Credential: string().label('Credential'),
    Email: string()
      .label('Email')
      .email('Please enter a valid email address')
      .required('Email is required'),
    Type: string().label('Type').required(),
    Position_Title: string().label('Position/Title'),
    Organization: string().label('Organization'),
    Country: string().label('Country'),
    State: string().label('State'),
    City: string().label('City'),
    Phone: string().label('Phone')
  })

export const pdfConfigurationSchema = () =>
  object({
    pageSize: string().label('Page Size').required(),
    orientation: string().label('First Name').required()
  })
